module.exports = __webpack_public_path__ + "media/flags/sb-194f33c8.svg";